import { Field, FieldArray } from 'formik'
import React from 'react'
import _get from 'lodash/get'
import Button from '../Button'
import { SimpleField } from '../../formik/Fields'
import { requiredValidator } from '../../../_common/core/validation'

const CustomFieldOptions = props => {
  const { values, errors, fieldName, addBtnLabel } = props
  const options = _get(values, fieldName) || []
  const error = _get(errors, fieldName) || ''
  const isEmptyOptionsError = Boolean(error) && typeof error === 'string'

  return (
    <div className="col-xs-12">
      <div className="cff-options">
        <FieldArray
          name={fieldName}
          render={arrayHelpers => (
            <div>
              <div style={{ margin: '0px 20px 20px' }}>
                <Button
                  className="btn btn-default btn-success"
                  type="button"
                  onClick={() => {
                    arrayHelpers.push({ name: '', value: '' })
                  }}
                >
                  <i className={'fa fa-fw fa-plus'} />
                  {addBtnLabel}
                </Button>
              </div>
              {isEmptyOptionsError && <div className="cff-sfield text-danger text-center">{error}</div>}
              {options?.map((_, index) => (
                <div key={index} style={{ marginTop: 15 }}>
                  <div className="col-xs-12 col-sm-5">
                    <Field
                      name={`${fieldName}[${index}].name`}
                      label="Name"
                      component={SimpleField}
                      validate={requiredValidator()}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-5">
                    <Field
                      name={`${fieldName}[${index}].value`}
                      label="Value"
                      component={SimpleField}
                      validate={requiredValidator()}
                    />
                  </div>
                  <div className="col-xs-2">
                    <Button
                      className="btn btn-seablue btn-shadow cff-btn-delete-option"
                      style={{ marginTop: 18 }}
                      type="button"
                      onClick={() => {
                        arrayHelpers.remove(index)
                      }}
                    >
                      <i className={'fa fa-trash'} />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        />
      </div>
    </div>
  )
}

export default CustomFieldOptions
